const ignoredTenant = (): boolean => {
  /* TODO: Ignore Humanforce accounts/tenant here */

  return false
}

interface IDelightedOptions {
  email?: string
  name?: string
  properties?: Record<string, string | boolean>
}

interface IDelighted {
  survey: (options: IDelightedOptions) => object
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any
const delighted: IDelighted | null = (window as any).delightedNps ? (window as any).delightedNps : null

const shouldUseDelighted = (): boolean => {
  try {
    return !ignoredTenant() && !!delighted /* TODO: Re-add prod environment check here */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return false
  }
}

const sendDelightedSurvey = (options: IDelightedOptions) => {
  if (delighted && shouldUseDelighted()) {
    delighted.survey(options)
  }
}

export { sendDelightedSurvey }
